import {Pipe, PipeTransform} from '@angular/core';
import {SessionStorageService} from '../services/session-storage.service';
import {DecimalPipe} from '@angular/common';

@Pipe({
    name: 'money'
})
export class MoneyPipe implements PipeTransform {
    amount: any;

    constructor(public sessionStorageService: SessionStorageService, public decimalPipe: DecimalPipe) {
    }

    transform(price: number, currency: string = '') {
        currency = currency == null ? '' : currency;
        this.amount = currency + ' ' + this.decimalPipe.transform(price, '1.2-2');
        return this.amount;
    }
}
